import React from 'react';
import Util from 'service/util';

import NoData from 'component/NoData';

const LHSTable = ({data}) =>
{
  if (!data) {
    return <p className="message red">讀取失敗，請聯絡系統管理員。</p>
  }
  if (!data.length) {
    return <NoData />
  }

  return (
    <table className="data-table lhs-table">
      <colgroup>
        <col width="50px"  id="col-lhs-loc" />
        <col width="350px" id="col-lhs-loc-name" />
        <col width="80px"  id="col-lhs-count" />
        <col width="200px" id="col-lhs-amount" />
        <col width="80px"  id="col-lhs-new-count" />
        <col width="120px" id="col-lhs-new-lic" />
        <col width="80px"  id="col-lhs-stop-count" />
        <col width="120px" id="col-lhs-stop-lic" />
      </colgroup>
      <thead>
        <tr>
          <th className="col-lhs-loc">#</th>
          <th className="col-lhs-loc-name">屋苑</th>
          <th className="col-lhs-count">戶數</th>
          <th className="col-lhs-amount">收款金額</th>
          <th className="col-lhs-new-count">新</th>
          <th className="col-lhs-new-lic">車牌</th>
          <th className="col-lhs-stop-count">停</th>
          <th className="col-lhs-stop-lic">車牌</th>
        </tr>
      </thead>
      <tbody>
        { data.map((d, i) =>
          <tr key={d.srv_dis + d.srv_loc}>
            <th className="col-lhs-loc">{d.srv_dis}{d.srv_loc}</th>
            <td className="col-lhs-loc-name">{ d.loc_name }</td>
            <td className="col-lhs-count">{ d.cnt_all }</td>
            <td className="col-lhs-amount">${ Util.nf2(d.amount) }</td>
            <td className="col-lhs-new-count">{ d.cnt_new }</td>
            <td className="col-lhs-new-lic">
              { !!d.lic_new && d.lic_new.map(l =>
                <div className="license">{ l }</div>
              )}
            </td>
            <td className="col-lhs-stop-count">{ d.cnt_term }</td>
            <td className="col-lhs-stop-lic">
              { !!d.lic_stop && d.lic_stop.map(l =>
                <div className="license">{ l }</div>
              )}
            </td>

          </tr>
        )}
      </tbody>
    </table>
  );

}

export default LHSTable;